<template>
  <div v-if="courseList && courseList.length" class="shopping-cart">
    <div class="shopping-cart-pc">
      <img
        class="bag"
        :src="bagImageUrl"
        alt=""
      />
      <cart-cont
        ref="cartCont"
        :courseList="courseList"
        :userList="userList"
        class="direction-left"
        :roomId="room_id"
      />
    </div>
  </div>
</template>

<script>
import CartCont from "./CartCont";
import { getCdnUrl } from "@saas/components/src";
import { mapState } from "vuex";
import { getRoomCart } from "@saas/server-api/src/live-sdk";
export default {
  name: "ShoppingCart",
  data: function () {
    return {
      userList: [],
      courseList: [],
      room_id: null,
      deviceOrientation: 1, //1竖屏0横屏
      showCart: false,
      isFullScreen: false,
      bagImageUrl: getCdnUrl("/cdn/room/images/bag.png"),
    };
  },
  computed: {
    ...mapState("live", ["roomInfo", "courseInfo", "imService"]),
  },
  methods: {
    joinedClass() {
      this.apiGetRoomCart();
      this.handleImServiceListener();
    },
    // 获取售卖信息
    apiGetRoomCart() {
      let params = {
        room_id: this.roomInfo.id,
        is_course_detail: true,
      };
      getRoomCart(params).then((res) => {
        if (res.code === 1) {
          let { status, course_map, course_ids } = res.data || {};
          if (status === 1) {
            if (course_map && course_ids?.length) {
              let arr = [];
              course_ids.forEach((item) => {
                if (course_map[item]) {
                  arr.push(course_map[item]);
                }
              });
              this.courseList = arr;
            }
          }
        }
      });
    },
    // im的监听事件
    handleImServiceListener() {
      console.log("handleImServiceListener__", this.imService);

      if (this.imService) {
        // 监听直播间自定义消息
        this.imService.on(
          "recvMGLiveRoomCustomMsg",
          this.handleLiveRoomCustomMsg
        );
      } else {
        console.error("imService__未准备好");
      }
    },
    // 监听直播间自定义消息
    handleLiveRoomCustomMsg(res) {
      console.log("==sale___handleLiveRoomCustomMsg", res);
      const { data, userId } = res;
      switch (data?.type) {
        case "ServerMsg":
          this.handleCustomServerMsg(data);
          break;
      }
    },
    handleCustomServerMsg(res) {
      try {
        console.log(res, "moguo-handleCustomServerMsg============");
        if (!res?.data) return;
        let { msg_type, msg_body } = res.data || {};
        switch (msg_type) {
          case "PublishSell":
            // 发布售卖
            this.apiGetRoomCart();
            break;
          case "StopSell":
            // 停止售卖
            this.courseList = [];
            break;
          case "FlashSale":
            // xxx正在抢购
            this.userList.push(msg_body);
            this.$refs?.cartCont?.refreshSwiper &&
              this.$refs?.cartCont?.refreshSwiper();
            break;
          case "UpdateSell":
            // 更新售卖
            this.apiGetRoomCart();
            break;
        }
      } catch (error) {
        console.log(error, "moguo-shopping-cart-component ======");
      }
    },
    closeDrawer() {
      this.drawer = false;
    },
  },
  components: {
    CartCont,
  },
  watch: {
    "roomInfo.id"(val) {
      if (val) {
        this.joinedClass();
      }
    },
    imService: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.handleImServiceListener();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.shopping-cart-pc {
  position: fixed;
  right: 85px;
  bottom: 114px;
  z-index: 1500;
  .bag {
    padding-top: 10px;
    padding-left: 10px;
    width: 66px;
    height: 66px;
    cursor: pointer;
    box-sizing: content-box;
  }
  .cart-cont {
    position: absolute;
    right: 0;
    bottom: 76px;
    display: none;
    opacity: 0;
    transition: all 0.3s ease;
    pointer-events: none;
    // &:hover {
    //   opacity: 1;
    //   pointer-events: auto;
    // }
  }
  &:hover {
    .cart-cont {
      display: block;
      opacity: 1;
      pointer-events: auto;
    }
  }
  .cart-cont.direction-left {
    position: absolute;
    right: 76px;
    bottom: 0;
    z-index: 1000;
  }
}
// @media screen and (orientation: landscape) {
//   .shopping-cart-mobile {
//     position: fixed;
//     left: 660px;
//     bottom: 15px;
//     width: 30px;
//     height: 30px;
//     .bag {
//       width: 30px;
//       height: 30px;
//     }
//   }
// }

// @media screen and (orientation: portrait) {
//   .shopping-cart-mobile {
//     position: fixed;
//     right: 15px;
//     top: 290px;
//     width: 30px;
//     height: 30px;
//     .bag {
//       width: 30px;
//       height: 30px;
//     }
//   }
// }

::v-deep .cart-drawer {
  height: auto !important;
  border-radius: 18px 18px 0 0;
  .close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 18px;
    height: 18px;
  }
  #el-drawer__title {
    display: none;
  }
  .el-drawer__body {
    overflow: hidden;
  }
}
</style>
